import { createSlice } from "@reduxjs/toolkit";

//%-<<*----------  REDUCERS AND ACTION TYPES  ----------*>>-%//

const errorsSlice = createSlice({
    name: "errors",
    initialState: {},

    reducers: {
        ADD_ERROR: (errors, { payload }) => {
            //->>: NAME OF PROP IN ERRORS OBJECT I THINK THE BEST WILL BE THE NAME IS LIKE THE ACTION THE THE ERROR OCCURRED ON.
            errors[payload.name] = payload.message;
        },
    },
});

export default errorsSlice.reducer;

//%-<<*----------  ACTIONS TYPES  ----------*>>-%//

export const { ADD_ERROR } = errorsSlice.actions;
